import React, { useState, useEffect } from "react";
import { fetchPayments } from "src/services/Payment/PaymentService";
import { loadingState, alertMessageState } from "src/atom/LoadingState";
import { useSetRecoilState } from "recoil";
import callApi from "src/services/Common/api";
import PaymentListing from "./PaymentListing";
import { insertBasicDetails } from "src/services/MainPage/GenericService";
import Loader from "./Loader";

const PaymentPage = ({ data }) => {
  const [payments, setPayments] = useState();
  const enableLoader = useSetRecoilState(loadingState);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPaymentsApiCall = async () => {
    enableLoader(true);
    var response = await fetchPayments(data?.milestoneId);
    if (response.success) {
      setPayments(response.body);
      enableLoader(false);
    } else {
      enableLoader(false);
      setAlertMessage(response.message);
    }
  };

  useEffect(() => {
    fetchPaymentsApiCall();
    handleRefresh();
  }, []);

  const handlePayButton = async () => {
    setIsLoading(true);
    setIsDisabled(true);
    enableLoader(true);
    try{
      var url = `/v1/api/init-payment/${data.milestoneId}`;
      const responseData = await callApi(
        url,
        "PUT",
        null,
        true,
        setAlertMessage
      );

      if (responseData.success != false) {
        enableLoader(true);
       if (responseData.body && Object.keys(responseData.body).length > 0) {
            console.log(responseData)
            var payment_url = responseData.body.paymentData;
            const form = document.createElement("form");
            form.method = "POST";
            form.action = payment_url.url;
            form.appendChild( Object.assign(document.createElement("input"), {
              type: "hidden",
              name: "encRequest",
              value: payment_url.encData,
            }));
            form.appendChild(Object.assign(document.createElement("input"), {
              type: "hidden",
              name: "access_code",
              value: payment_url.accessCode,
            }));
            document.body.appendChild(form);
            form.submit();
          }
        enableLoader(false);
      }

    }catch{

      enableLoader(false);
      setIsLoading(false);
      setIsDisabled(false);
    }finally{
      setIsLoading(false);


    }
    
  };

  const handleRefresh = async () => {
    setIsLoading(true);
    var url = `/v1/api/fetch-payment-status/${data.milestoneId}`;
    const responseData = await callApi(url, "GET", null, true, setAlertMessage);
    fetchPaymentsApiCall();
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const handleNext = async (e) => {
    e.preventDefault();
    enableLoader(true);
    data?.onChange(data?.activeIndex);
    enableLoader(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const response = await insertBasicDetails(formData, data.milestoneId);
    if (response.success) {
      data.onChange(data.activeIndex);
    } else {
      enableLoader(false);
      setAlertMessage(response.message);
    }
    enableLoader(false);
  };

  return (
    <>
      <div className="card">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          Payment
        </div>
        <div className="card-body">
          <div className="d-flex mb-4">
            <span style={{ fontSize: "20px" }}>
              <b>Amount to be Paid: ₹ {payments?.amount}</b>
            </span>
            <div className="ms-auto d-flex">
              {payments?.amount !== 0 && (
                <>
                  {payments?.previousPayments &&
                    payments.previousPayments.length > 0 && (
                      <button
                        type="button"
                        className="btn btn-sm btn-info text-white"
                        onClick={handleRefresh}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            />{" "}
                            Verifing Payments
                          </>
                        ) : (
                          "Verify Pending Payments"
                        )}
                      </button>
                    )}
                  <button
                    type="button"
                    className="btn btn-sm btn-success text-white ms-4"
                    onClick={handlePayButton}
                    disabled={isDisabled}
                  >
                    Pay Now
                  </button>
                </>
              )}
            </div>
            <Loader isDisabled={isDisabled} />
          </div>
          <PaymentListing previousPayments={payments?.previousPayments} />

          <div
            className="mt-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {data?.activeIndex !== 0 && data?.showBack && (
              <button
                type="button"
                className="btn btn-sm btn-info text-white"
                onClick={data?.goBack}
              >
                Back
              </button>
            )}
            {data?.showCancel && (
              <>
                <div style={{ marginRight: "auto" }}>
                  {
                    <button
                      className="btn btn-sm btn-danger text-white"
                      type="button"
                      onClick={() => data?.setEditMode(false)}
                    >
                      Cancel
                    </button>
                  }
                </div>
              </>
            )}
            {payments?.amount == 0 && (
              <>
                {data?.showSubmit && (
                  <>
                    <div style={{ marginLeft: "auto" }}>
                      {
                        <button
                          className="btn btn-sm btn-success text-white"
                          type="button"
                          onClick={(e) => handleSubmit(e)}
                        >
                          Submit
                        </button>
                      }
                    </div>
                  </>
                )}
                {data?.showNext && (
                  <div>
                    {
                      <button
                        className="btn btn-sm btn-success text-white"
                        type="button"
                        onClick={handleNext}
                      >
                        Next
                      </button>
                    }
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentPage;
